// src/index.ts
function getValue(element) {
  return element.value || element.textContent || element.innerText || element.innerHTML;
}
function isDisabled(element) {
  return element.disabled || element.getAttribute("aria-disabled") === "true" || element.getAttribute("aria-hidden") === "true";
}
var Collection = class {
  constructor(items, loop = true) {
    this.loop = loop;
    this._items = [];
    this._indexes = /* @__PURE__ */ new Map();
    for (const item of items) {
      const value = getValue(item);
      if (!value || this._indexes.has(value)) {
        continue;
      }
      this._indexes.set(value, this._items.length);
      this._items.push(item);
    }
  }
  size() {
    return this._items.length;
  }
  _find(startIndex, dir) {
    let index = startIndex;
    const n = this._items.length;
    for (let i = 0; i < n; i++) {
      if (index < 0 || index >= n) {
        if (this.loop) {
          index = (index + n) % n;
        } else {
          break;
        }
      }
      const item = this._items[index];
      if (item && !isDisabled(item)) {
        return getValue(item);
      }
      index += dir;
    }
    return null;
  }
  /**
   * Returns the first enabled value.
   */
  first() {
    return this._find(0, 1);
  }
  /**
   * Returns the last enabled value.
   */
  last() {
    return this._find(this.size() - 1, -1);
  }
  /**
   * Returns the next enabled value.
   */
  next(value) {
    if (value == null) {
      return this.first();
    }
    const index = this._indexes.get(value);
    if (index == null) {
      return this.first();
    }
    return this._find(index + 1, 1);
  }
  /**
   * Returns the previous enabled value.
   */
  prev(value) {
    if (value == null) {
      return this.last();
    }
    const index = this._indexes.get(value);
    if (index == null) {
      return this.last();
    }
    return this._find(index - 1, -1);
  }
  /**
   * Finds an element from its value.
   */
  getElement(value) {
    var _a;
    const index = this._indexes.get(value);
    if (index == null) return null;
    return (_a = this._items[index]) != null ? _a : null;
  }
  /**
   * Returns all values.
   */
  getValues() {
    return this._items.map(getValue);
  }
};
var defaultItemFilter = ({ value, query }) => {
  if (!query) {
    return true;
  }
  return value.toLowerCase().replace(/\s/g, "").includes(query.toLowerCase().replace(/\s/g, ""));
};
export {
  Collection,
  defaultItemFilter
};
